import { Routes } from '@angular/router';
import { NonStandardModalEntryComponent } from '@design/modals/non-standard-modal/non-standard-modal-entry.component';
import { PensionContributionsAdvancedViewComponent } from './contributions/pension-contributions-advanced-view.component';
import { FeatureFlagEnabledRouteGuard, getFeatureFlagKey } from '@security/authorization/feature-flag-enabled.route-guard';
import { BureauAuthorisedRouteGuard } from '@security/authorization/bureau-authorised.route-guard';

export const pensionConnectModalRoutes: Routes = [
  {
    path: 'pension-connect/submissions/contributions',
    outlet: 'modal',
    component: NonStandardModalEntryComponent,
    canActivate: [FeatureFlagEnabledRouteGuard, BureauAuthorisedRouteGuard],
    data: {
      ...getFeatureFlagKey('pensionConnect'),
      anyBureauProfilePermissions: ['IsBureauUser'],
      componentType: PensionContributionsAdvancedViewComponent,
      modalType: 'Custom',
      panelClass: 'advanced-reports-modal-panel',
      fullScreen: true
    },
    runGuardsAndResolvers: 'always'
  }
];
